import { navigate } from '@reach/router';
import Button from 'components/button/Button';
import { Modal } from 'components/modal/Modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalTypes, closeModal, selectModalState } from 'reducers/modal';

export const ContactSupportModal = () => {
    const modalState = useSelector(selectModalState);
    const dispatch = useDispatch();

    if (modalState.modalType !== ModalTypes.CONTACT_SUPPORT) return null;

    return (
        <Modal
            title="Contact Support"
            onCloseModal={() => {
                dispatch(closeModal());
            }}
            className="ContactSupportModal"
            customButtons={
                <div className="ModalNavigation">
                    <Button onClick={() => dispatch(closeModal())}>OK</Button>
                </div>
            }
        >
            <div className="Text" style={{ fontSize: 14 }}>
                Please contact support to update your organization's records.
            </div>
        </Modal>
    );
};
